import featuredImage1 from "../images/featured-img-1.webp" 
import featuredImage2 from "../images/featured-img-2.webp" 
import featuredImage3 from "../images/featured-img-3.webp" 
import featuredImage4 from "../images/featured-img-4.webp" 
import featuredImage5 from "../images/featured-img-5.webp" 
import featuredImage6 from "../images/featured-img-6.webp" 
import featuredImage7 from "../images/featured-img-7.webp" 
import featuredImage8 from "../images/featured-img-8.webp" 
import featuredImage9 from "../images/featured-img-9.webp" 
import featuredImage10 from "../images/featured-img-10.webp" 
import featuredImage11 from "../images/featured-img-11.webp" 
import featuredImage12 from "../images/featured-img-12.webp" 






const FeaturedItemsImage =[
    {
        "id" : 1,
        "imageLink" : featuredImage1,
        "altText": `KLEO Soap Dispenser Lotion Dispenser - Made of Natural Stone - Luxury Bathroom Accessories Bath Set (Grey)`,
        "desc": "",
        "sku":"B07RLFQS39",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-soap-dispenser-lotion-dispenser-made-of-natural-stone-luxury-bathroom-accessories-bath-set-green?_pos=1&_sid=f9a219d6c&_ss=r&variant=44718707376297",
        "modalId": "featuredImg1",
        "price": "819.00",
        "salePrice": ""
    },
    {
        "id" : 2,
        "imageLink" : featuredImage2,
        "altText": `KLEO Natural Stone Soap Dish Bath Accessories For Bath, Tub Or Wash Basin In Two Tone Black/White Color`,
        "desc": "",
        "sku":"B01AW4416W",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-double-sided-soap-dish-made-of-natural-black-stone-and-white-marble-bath-kitchen-accessories-1?_pos=1&_sid=49ffe1a15&_ss=r&variant=44719151972521",
        "modalId": "featuredImg2",
        "price": "252.00",
        "salePrice": ""
    },
    {
        "id" : 3,
        "imageLink" : featuredImage3,
        "altText": `Bathroom Accessory Set Made from Natural Stone - Bath Accessories Set of 4 Includes Soap Dispenser, Toothbrush Holder, Tumbler and Soap Dish (Green)`,
        "desc": "",
        "sku":"B01E76QYKW",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-bathroom-accessory-set-made-from-natural-stone-bath-accessories-set-of-4-includes-soap-dispenser-toothbrush-holder-tumbler-and-soap-dish-green-1?_pos=1&_sid=289ae582e&_ss=r&variant=44719155577001",
        "modalId": "featuredImg3",
        "price": "2,159.00",
        "salePrice": ""
    },
    {
        "id" : 4,
        "imageLink" : featuredImage4,
        "altText": `KLEO Marble Salt and Spice Holder with Lid | Small Container | Stone Salt Box/Canister for Kitchen and Dining | Saunf Holder (White)`,
        "desc": "",
        "sku":"B0D8W9XWY3",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-marble-salt-and-spice-holder-with-lid-small-container-2x3in-stone-salt-box-canister-for-kitchen-and-dining-saunf-holder-beige-1?_pos=1&_sid=6061717e8&_ss=r",
        "modalId": "featuredImg4",
        "price": "623.00",
        "salePrice": ""
    },
    {
        "id" : 5,
        "imageLink" : featuredImage5,
        "altText": `KLEO Coasters Set of Natural Stone - Natural Water Absorbent, Unique Table Coaster Set (Set of 4)`,
        "desc": "",
        "sku":"B079YRK1NW",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-coaster-set-made-of-natural-rainbow-stone-natural-water-absorbent-unique-table-coaster-set-square?_pos=1&_sid=38edc18f0&_ss=r&variant=44718829240489",
        "modalId": "featuredImg5",
        "price": "262.00",
        "salePrice": ""
    },
    {
        "id" : 6,
        "imageLink" : featuredImage6,
        "altText": `KLEO Wooden Dinner Set Decorative Plates Dinner Thali Set - Plate Glass 2 Bowls and Spoon - Wood - 12" inch Dia. - Brown`,
        "desc": "",
        "sku":"B0F6NRNWN7",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-wooden-dinner-set-decorative-plates-dinner-thali-set-plate-glass-2-bowls-and-spoon-wood-12-inch-dia-brown?variant=45188610556073",
        "modalId": "featuredImg6",
        "price": "648.00",
        "salePrice": ""
    },
    {
        "id" : 7,
        "imageLink" : featuredImage7,
        "altText": `KLEO Wooden Organizer Stand Caddy - Mango Wood Cutlery Holder, Tableware Storage Box for Kitchen, Dining Table | Spoon, Knife, Fork, Chopstick, Spices Organizer | Pen Stand & Stationery Box`,
        "desc": "",
        "sku":"B0DFTGQVZC",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-wooden-organizer-stand-caddy-mango-wood-cutlery-holder-tableware-storage-box-for-kitchen-dining-table-spoon-knife-fork-chopstick-spices-organizer-pen-stand-stationery-box?_pos=1&_sid=f9963adaf&_ss=r",
        "modalId": "featuredImg7",
        "price": "701.00",
        "salePrice": ""
    },
    {
        "id" : 8,
        "imageLink" : featuredImage8,
        "altText": `KLEO Wooden Casserole with Lid, Bread Basket for Roti, Hot, Masala Box - Serving Bowl for Kitchen and Home, Accessory and Jewellery Box | 23 x 23 × 10 cm | Handcrafted in India`,
        "desc": "",
        "sku":"B0DGQKWJLL",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-wooden-casserole-with-lid-bread-basket-for-roti-hot-masala-box-serving-bowl-for-kitchen-and-home-accessory-and-jewellery-box-23-x-23-10-cm-handcrafted-in-india?_pos=1&_sid=8c602683d&_ss=r",
        "modalId": "featuredImg8",
        "price": "1,234.00",
        "salePrice": ""
    }
]



const FeaturedItemsTab =[
    {
        "id" : 9,
        "imageLink" : featuredImage9,
        "altText": `KLEO Sofa Armrest Tray - Handcrafted Acacia Wood Tambour Tray | Flexible & Foldable Dining Table Mat | Water Resistant & Stain Proof | Ideal for Food, Drinks, Snacks, Cup Coaster`,
        "desc": "",
        "sku":"B0DFTQ9C2R",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-sofa-armrest-tray-handcrafted-acacia-wood-tambour-tray-flexible-foldable-dining-table-mat-water-resistant-stain-proof-ideal-for-food-drinks-snacks-cup-coaster?_pos=1&_sid=4f5837e64&_ss=r",
        "modalId": "featuredImg9",
        "price": "1,200.00",
        "salePrice": ""
    },
    {
        "id" : 10,
        "imageLink" : featuredImage10,
        "altText": `KLEO 5" Wide Black Natural Stone Mortar and Pestle Set as Spice, Medicine Grinder Masher - Okhli And Musal`,
        "desc": "",
        "sku":"B0156ODXJ4",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-5-diameter-natural-stone-mortar-and-pestle-set-as-spice-grinder-medicine-masher-okhli-musal-black?_pos=1&_sid=1fc2b5148&_ss=r&variant=44719164719273",
        "modalId": "featuredImg10",
        "price": "941.00",
        "salePrice": ""
    },
    {
        "id" : 11,
        "imageLink" : featuredImage11,
        "altText": `KLEO Marble Stone Shiva Lingam Shiv Ling Idol Murti for Daily Pooja (3.5" Height), Black, Shiva`,
        "desc": "",
        "sku":"B075ZSS3QX",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-natural-black-stone-shivalingam-shivling-shiv-ling-idol-statue-figurine-for-home-decor-and-pooja-3-5-inches?_pos=1&_sid=881ff0a82&_ss=r&variant=44719168684201",
        "modalId": "featuredImg11",
        "price": "339.00",
        "salePrice": ""
    },
    {
        "id" : 12,
        "imageLink" : featuredImage12,
        "altText": `KLEO Marble Chopping Board Cutting Board Cheese Platter - Can be Used as Cheese Salami Cold Meat Platter`,
        "desc": "",
        "sku":"B07415SW5M",
        "type": "",
        "productLink": "https://indusmela.in/products/kleo-marble-cutting-board-cheese-platter-multi-purpose-serving-platter-white?_pos=1&_sid=dd19e906d&_ss=r&variant=44719165309097",
        "modalId": "featuredImg12",
        "price": "842.00",
        "salePrice": ""
    }
]

const AllFeaturedItems = FeaturedItemsImage.concat(FeaturedItemsTab)


export { FeaturedItemsImage, FeaturedItemsTab, AllFeaturedItems }